document.addEventListener("DOMContentLoaded", function() {
  var state = { 1: null, 2: null, 3: null, 4: null };
  var activeStep = 1;

  var tabButtons = document.querySelectorAll('.bundle-tab-btn');
  var productCards = document.querySelectorAll('.bundle-product-card');
  var quickAddTriggers = document.querySelectorAll('.quick-add-trigger');
  var removeBtns = document.querySelectorAll('.remove-slot-item');

  // Helper dictionary to cleanly reset layout states
  var defaultLabels = { 1: "Pick Any Sweater", 2: "Pick Any Hoodie", 3: "Pick Any Bag", 4: "Pick Any Item" };

  // --- Pre-select first color variant on load for all color options ---
  function preselectDefaultColors() {
    productCards.forEach(function(card) {
      var colorRow = card.querySelector('[data-option-index="option1"]');
      if (colorRow) {
        var selectedColor = colorRow.querySelector('.selected, .bundle-color-swatch-btn.selected');
        if (!selectedColor) {
          var firstColorSwatch = colorRow.querySelector('.bundle-color-swatch-btn');
          if (firstColorSwatch) {
            // Programmatically select first color
            firstColorSwatch.classList.add('selected');
            
            // Sync main product card image
            var mainCardImg = card.querySelector('.main-card-image');
            if (mainCardImg && firstColorSwatch.dataset.variantImg) {
              mainCardImg.src = firstColorSwatch.dataset.variantImg;
            }
          }
        }
      }
    });
  }

  // --- Reset Slot UIs globally before processing map changes ---
  function resetAllSlotsUI() {
    for (var step = 1; step <= 4; step++) {
      var slot = document.getElementById('slot-' + step);
      if (slot) {
        var imageElement = slot.querySelector('.slot-img');
        var labelElement = slot.querySelector('.slot-placeholder-text');
        var removeBtn = slot.querySelector('.remove-slot-item');

        if (imageElement) {
          imageElement.src = "";
          imageElement.classList.add('hidden');
        }
        if (labelElement) {
          labelElement.textContent = defaultLabels[step];
        }
        if (removeBtn) {
          removeBtn.removeAttribute('data-variant-id');
          removeBtn.classList.add('hidden');
        }
      }
    }
  }

  // --- Sync Existing Cart Items on Page Load and Intercepted Drawer Changes ---
  function syncExistingCart() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cartData) {
        
        if (cartData && cartData.items) {
          var expandedItems = [];
          cartData.items.forEach(function(item) {
            var titleLower = item.title.toLowerCase();
            var handleLower = item.handle.toLowerCase();
            
            if (
              titleLower.includes('free made me smile bag') || 
              handleLower.includes('free-made-me-smile-bag') ||
              item.variant_id.toString() === '47122303353136' || 
              titleLower.includes('shipping protection') || 
              titleLower.includes('heroes club') || 
              titleLower.includes('early dispatch')
            ) {
              return; 
            } 

            for (var q = 0; q < item.quantity; q++) {
              expandedItems.push(item);
            }
          });

          for (var i = 1; i <= 4; i++) {
            if (state[i]) {
              var stillExistsIndex = expandedItems.findIndex(function(ex) {
                return ex.variant_id === state[i].id;
              });
              
              if (stillExistsIndex !== -1) {
                expandedItems.splice(stillExistsIndex, 1);
              } else {
                state[i] = null;
              }
            }
          }

          expandedItems.forEach(function(item) {
            for (var i = 1; i <= 4; i++) {
              if (!state[i]) {
                state[i] = { 
                  id: item.variant_id, 
                  product_id: item.product_id, 
                  title: item.title, 
                  image: item.image 
                };
                break;
              }
            }
          });
        } else {
          state = { 1: null, 2: null, 3: null, 4: null };
        }

        for (var step = 1; step <= 4; step++) {
          var slot = document.getElementById('slot-' + step);
          if (slot) {
            var imageElement = slot.querySelector('.slot-img');
            var labelElement = slot.querySelector('.slot-placeholder-text');
            var removeBtn = slot.querySelector('.remove-slot-item');

            if (state[step]) {
              slot.classList.remove('blank-bundle'); 
              
              if (imageElement) {
                imageElement.src = state[step].image;
                imageElement.classList.remove('hidden');
              }
              if (labelElement) labelElement.textContent = state[step].title;
              if (removeBtn) {
                removeBtn.dataset.variantId = state[step].id;
                removeBtn.classList.remove('hidden');
              }
            } else {
              slot.classList.add('blank-bundle'); 
              
              if (imageElement) {
                imageElement.src = "";
                imageElement.classList.add('hidden');
              }
              if (labelElement) labelElement.textContent = defaultLabels[step];
              if (removeBtn) {
                removeBtn.removeAttribute('data-variant-id');
                removeBtn.classList.add('hidden');
              }
            }
          }
        }
        
        calculateActiveStepAndFilters();
        updateProductCardButtonStates(); 
        preselectDefaultColors(); // Run default colors check after sync
      })
      .catch(function(err) {
        console.error("Error syncing bundle with active cart items:", err);
        calculateActiveStepAndFilters();
        updateProductCardButtonStates();
        preselectDefaultColors();
      });
  }

  // --- Dynamic Card Button State UI Manager ---
  function updateProductCardButtonStates() {
    var activeVariantIds = [];
    var activeProductIds = [];
    
    for (var step in state) {
      if (state[step]) {
        if (state[step].id) activeVariantIds.push(state[step].id.toString());
        if (state[step].product_id) activeProductIds.push(parseInt(state[step].product_id));
      }
    }

    quickAddTriggers.forEach(function(btn) {
      var card = btn.closest('.bundle-product-card');
      
      var btnVariantId = btn.dataset.id ? btn.dataset.id.toString() : '';
      var cardProductId = card && card.dataset.productId ? parseInt(card.dataset.productId) : null;

      var isItemInCart = false;
      var matchedStateItem = null;

      if (cardProductId && activeProductIds.includes(cardProductId)) {
        isItemInCart = true;
        matchedStateItem = Object.values(state).find(function(s) {
          return s && parseInt(s.product_id) === cardProductId;
        });
      } else if (activeVariantIds.includes(btnVariantId)) {
        isItemInCart = true;
        matchedStateItem = Object.values(state).find(function(s) {
          return s && s.id.toString() === btnVariantId;
        });
      }

      if (isItemInCart && matchedStateItem) {
        btn.dataset.id = matchedStateItem.id.toString(); 
        btn.textContent = "Remove"; 
        btn.classList.add('bundle-remove-mode');
        btn.style.backgroundColor = "#ff4d4d"; 
        btn.style.color = "#ffffff";
      } else {
        if (card && card.dataset.defaultVariantId && btn.dataset.id !== card.dataset.defaultVariantId) {
            btn.dataset.id = card.dataset.defaultVariantId;
        }
        btn.textContent = "Add to Bundle"; 
        btn.classList.remove('bundle-remove-mode');
        btn.style.backgroundColor = "";
        btn.style.color = "";
      }
    });
  }

  // --- Process Card Item Discards ---
  function executeCardRemoval(targetVariantId) {
    var stepToRemove = null;
    for (var step in state) {
      if (state[step] && state[step].id.toString() === targetVariantId.toString()) {
        stepToRemove = step;
        break;
      }
    }

    if (stepToRemove) {
      state[stepToRemove] = null;
      var slot = document.getElementById('slot-' + stepToRemove);
      if (slot) {
        slot.classList.add('blank-bundle'); 

        var imageElement = slot.querySelector('.slot-img');
        var labelElement = slot.querySelector('.slot-placeholder-text');
        var removeBtn = slot.querySelector('.remove-slot-item');

        if (imageElement) {
          imageElement.src = "";
          imageElement.classList.add('hidden');
        }
        if (labelElement) {
          labelElement.textContent = defaultLabels[stepToRemove] || "Empty Slot";
        }
        if (removeBtn) {
          removeBtn.removeAttribute('data-variant-id');
          removeBtn.classList.add('hidden');
        }
      }
    }

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cartData) {
        var currentItem = cartData.items.find(function(item) {
          return item.variant_id.toString() === targetVariantId.toString();
        });

        var targetQuantity = 0;
        if (currentItem && currentItem.quantity > 1) {
          targetQuantity = currentItem.quantity - 1;
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: targetVariantId, quantity: targetQuantity })
        });
      })
      .then(function(response) { return response.json(); })
      .then(function(cartData) {
        const FREE_HAT_VARIANT_ID = '47122303353136';
        const remainingBundleItems = cartData.items.filter(item => item.variant_id.toString() !== FREE_HAT_VARIANT_ID);
        const totalBundleQuantity = remainingBundleItems.reduce((sum, item) => sum + item.quantity, 0);
        
        if (totalBundleQuantity < 2) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: FREE_HAT_VARIANT_ID, quantity: 0 })
          }).then(res => res.json());
        }
        return cartData;
      })
      .then(function() {
        syncExistingCart();
        refreshDawnCartDrawer();
      })
      .catch(err => console.error("Error updating bundle items:", err));
  }
  
  // --- Extracted Step Strategy & Interface Calculation ---
  function calculateActiveStepAndFilters() {
    var completedCount = 0;
    for (var i = 1; i <= 4; i++) {
      if (state[i]) completedCount++;
    }

    // --- CHECKOUT BUTTON VISIBILITY CONTROL ---
    var checkoutWrapper = document.querySelector('.checkout-wrapper-main');
    if (checkoutWrapper) {
      if (completedCount === 4) {
        checkoutWrapper.style.display = 'flex'; // Reveals wrapper when all steps are completed
      } else {
        checkoutWrapper.style.display = 'none'; // Keeps wrapper hidden while bundle is incomplete
      }
    }

    if (!state[1]) activeStep = 1;
    else if (!state[2]) activeStep = 2;
    else if (!state[3]) activeStep = 3;
    else if (!state[4]) activeStep = 4;
    else activeStep = 4;

    tabButtons.forEach(function(b) { b.classList.remove('active'); });
    
    var activeFilter = 'sweater';
    if (activeStep === 1) activeFilter = 'sweater';
    else if (activeStep === 2) activeFilter = 'hoodie';
    else if (activeStep === 3) activeFilter = 'tees';
    else if (activeStep === 4) activeFilter = 'bag';

    var targetTab = document.querySelector('.bundle-tab-btn[data-filter="' + activeFilter + '"]');
    if (targetTab && completedCount < 4) {
      targetTab.classList.add('active');
      filterProducts(targetTab.dataset.filter);
    } else {
      var currentActiveTab = Array.from(tabButtons).find(function(btn) { return btn.classList.contains('active'); });
      if (!currentActiveTab && targetTab) targetTab.classList.add('active');
    }

    updateTimelineProgress();
  }

  function updateTimelineProgress() {
    var completedCount = 0;
    for (var i = 1; i <= 4; i++) {
      if (state[i]) completedCount++;
    }

    var fillPercent = 0;
    if (completedCount === 1) fillPercent = 20;
    else if (completedCount === 2) fillPercent = 40;
    else if (completedCount === 3) fillPercent = 60;
    else if (completedCount === 4) fillPercent = 100;

    var fillBar = document.getElementById('timeline-bar-fill');
    if (fillBar) fillBar.style.width = fillPercent + '%';

    for (var i = 1; i <= 4; i++) {
      var node = document.getElementById('node-' + i);
      if (node) {
        node.classList.remove('completed-node', 'active-node');
        if (state[i]) {
          node.classList.add('completed-node');
        } else if (i === activeStep) {
          node.classList.add('active-node');
        }
      }
    }

    var giftNodeHat = document.getElementById('node-gift-hat');
    var giftSlotHat = document.getElementById('slot-gift-hat');
    
    if (completedCount >= 2) {
      if (giftNodeHat) {
        giftNodeHat.classList.add('unlocked');
        var hatToast = giftNodeHat.querySelector('.hat-toast');
        var hatUnderLabel = giftNodeHat.querySelector('.gift-locked-label-under');
        if (hatToast) hatToast.classList.remove('hidden');
        if (hatUnderLabel) hatUnderLabel.classList.add('hidden');
      }

      if (giftSlotHat) {
        giftSlotHat.classList.replace('status-locked', 'status-unlocked');
        var hatTag = giftSlotHat.querySelector('.gift-ribbon-tag');
        if (hatTag) hatTag.textContent = "UNLOCKED";
        var hatIcon = giftSlotHat.querySelector('.center-symbol-icon');
        if (hatIcon) {
          hatIcon.innerHTML = `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.5 6.25H20.9875C21.15 5.7375 21.25 5.125 21.25 4.375C21.25 1.9625 19.2875 0 16.875 0C14.85 0 13.5 1.85 12.625 3.8625C11.7625 1.975 10.3375 0 8.125 0C5.7125 0 3.75 1.9625 3.75 4.375C3.75 5.125 3.85 5.7375 4.0125 6.25H2.5C1.125 6.25 0 7.375 0 8.75C0 10.125 1.125 11.25 2.5 11.25H22.5C23.875 11.25 25 10.125 25 8.75C25 7.375 23.875 6.25 22.5 6.25ZM16.875 2.5C17.9125 2.5 18.75 3.3375 18.75 4.375C18.75 6.25 17.9625 6.25 17.5 6.25H14.4C15.0375 4.275 15.9625 2.5 16.875 2.5ZM6.25 4.375C6.25 3.3375 7.0875 2.5 8.125 2.5C9.2375 2.5 10.2625 4.4125 10.875 6.25H7.5C7.0375 6.25 6.25 6.25 6.25 4.375ZM3.75 13.75H2.5V22.5C2.5 23.875 3.625 25 5 25H11.25V13.75H3.75ZM20 13.75H13.75V25H20C21.375 25 22.5 23.875 22.5 22.5V13.75H20Z" fill="white"/></svg>`;
        }
      }
    } else {
      if (giftNodeHat) {
        giftNodeHat.classList.remove('unlocked');
        var hatToast = giftNodeHat.querySelector('.hat-toast');
        var hatUnderLabel = giftNodeHat.querySelector('.gift-locked-label-under');
        if (hatToast) hatToast.classList.add('hidden');
        if (hatUnderLabel) hatUnderLabel.classList.remove('hidden');
      }

      if (giftSlotHat) {
        giftSlotHat.classList.replace('status-unlocked', 'status-locked');
        var hatTag = giftSlotHat.querySelector('.gift-ribbon-tag');
        if (hatTag) hatTag.textContent = "LOCKED";
        var hatIcon = giftSlotHat.querySelector('.center-symbol-icon');
        if (hatIcon) {
          hatIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="0 0 22 27" fill="none"><path d="M11 0C12.8234 0 14.572 0.711159 15.8614 1.97703C17.1507 3.2429 17.875 4.95979 17.875 6.75V10.8C18.969 10.8 20.0182 11.2267 20.7918 11.9862C21.5654 12.7457 22 13.7759 22 14.85V22.95C22 24.0241 21.5654 25.0543 20.7918 25.8138C20.0182 26.5733 18.969 27 17.875 27H4.125C3.03098 27 1.98177 26.5733 1.20818 25.8138C0.434597 25.0543 0 24.0241 0 22.95V14.85C0 13.7759 0.434597 12.7457 1.20818 11.9862C1.98177 11.2267 3.03098 10.8 4.125 10.8V6.75C4.125 4.95979 4.84933 3.2429 6.13864 1.97703C7.42795 0.711159 9.17664 0 11 0ZM11 16.2C10.3062 16.1998 9.63797 16.457 9.12925 16.9202C8.62052 17.3834 8.30891 18.0182 8.25688 18.6975L8.25 18.9C8.25 19.434 8.41128 19.956 8.71346 20.4C9.01563 20.4 9.44512 21.1901 9.94762 21.3945C10.4501 21.5988 11.0031 21.6523 11.5365 21.5481C12.0699 21.5481 12.5599 21.1868 12.9445 20.8092C13.3291 20.4316 13.5911 19.9505 13.6972 19.4267C13.8033 18.903 13.7488 18.3601 13.5407 17.8668C13.3325 17.3734 12.9801 16.9517 12.5278 16.655C12.0756 16.3584 11.5439 16.2 11 16.2ZM11 2.7C9.90598 2.7 8.85677 3.1267 8.08318 3.88622C7.3096 4.64574 6.875 5.67587 6.875 6.75V10.8H15.125V6.75C15.125 5.67587 14.6904 4.64574 13.9168 3.88622C13.1432 3.1267 12.094 2.7 11 2.7Z" fill="white"/></svg>`;
        }
      }
    }

    var giftNodeBag = document.getElementById('node-gift-bag');
    var giftSlotBag = document.getElementById('slot-gift-bag');
    
    if (completedCount === 4) {
      if (giftNodeBag) {
        giftNodeBag.classList.add('unlocked');
        var bagToast = giftNodeBag.querySelector('.bag-toast');
        var bagUnderLabel = giftNodeBag.querySelector('.gift-locked-label-under');
        if (bagToast) bagToast.classList.remove('hidden');
        if (bagUnderLabel) bagUnderLabel.classList.add('hidden');
      }

      if (giftSlotBag) {
        giftSlotBag.classList.replace('status-locked', 'status-unlocked');
        var bagTag = giftSlotBag.querySelector('.gift-ribbon-tag');
        if (bagTag) bagTag.textContent = "UNLOCKED";
        var bagIcon = giftSlotBag.querySelector('.center-symbol-icon');
        if (bagIcon) {
          bagIcon.innerHTML = `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.5 6.25H20.9875C21.15 5.7375 21.25 5.125 21.25 4.375C21.25 1.9625 19.2875 0 16.875 0C14.85 0 13.5 1.85 12.625 3.8625C11.7625 1.975 10.3375 0 8.125 0C5.7125 0 3.75 1.9625 3.75 4.375C3.75 5.125 3.85 5.7375 4.0125 6.25H2.5C1.125 6.25 0 7.375 0 8.75C0 10.125 1.125 11.25 2.5 11.25H22.5C23.875 11.25 25 10.125 25 8.75C25 7.375 23.875 6.25 22.5 6.25ZM16.875 2.5C17.9125 2.5 18.75 3.3375 18.75 4.375C18.75 6.25 17.9625 6.25 17.5 6.25H14.4C15.0375 4.275 15.9625 2.5 16.875 2.5ZM6.25 4.375C6.25 3.3375 7.0875 2.5 8.125 2.5C9.2375 2.5 10.2625 4.4125 10.875 6.25H7.5C7.0375 6.25 6.25 6.25 6.25 4.375ZM3.75 13.75H2.5V22.5C2.5 23.875 3.625 25 5 25H11.25V13.75H3.75ZM20 13.75H13.75V25H20C21.375 25 22.5 23.875 22.5 22.5V13.75H20Z" fill="white"></path></svg>`;
        }
      }
    } else {
      if (giftNodeBag) {
        giftNodeBag.classList.remove('unlocked');
        var bagToast = giftNodeBag.querySelector('.bag-toast');
        var bagUnderLabel = giftNodeBag.querySelector('.gift-locked-label-under');
        if (bagToast) bagToast.classList.add('hidden');
        if (bagUnderLabel) bagUnderLabel.classList.remove('hidden');
      }

      if (giftSlotBag) {
        giftSlotBag.classList.replace('status-unlocked', 'status-locked');
        var bagTag = giftSlotBag.querySelector('.gift-ribbon-tag');
        if (bagTag) bagTag.textContent = "LOCKED";
        var bagIcon = giftSlotBag.querySelector('.center-symbol-icon');
        if (bagIcon) {
          bagIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="27" viewBox="0 0 22 27" fill="none"><path d="M11 0C12.8234 0 14.572 0.711159 15.8614 1.97703C17.1507 3.2429 17.875 4.95979 17.875 6.75V10.8C18.969 10.8 20.0182 11.2267 20.7918 11.9862C21.5654 12.7457 22 13.7759 22 14.85V22.95C22 24.0241 21.5654 25.0543 20.7918 25.8138C20.0182 26.5733 18.969 27 17.875 27H4.125C3.03098 27 1.98177 26.5733 1.20818 25.8138C0.434597 25.0543 0 24.0241 0 22.95V14.85C0 13.7759 0.434597 12.7457 1.20818 11.9862C1.98177 11.2267 3.03098 10.8 4.125 10.8V6.75C4.125 4.95979 4.84933 3.2429 6.13864 1.97703C7.42795 0.711159 9.17664 0 11 0ZM11 16.2C10.3062 16.1998 9.63797 16.457 9.12925 16.9202C8.62052 17.3834 8.30891 18.0182 8.25688 18.6975L8.25 18.9C8.25 19.434 8.41128 19.956 8.71346 20.4C9.01563 20.4 9.44512 21.1901 9.94762 21.3945C10.4501 21.5988 11.0031 21.6523 11.5365 21.5481C12.0699 21.5481 12.5599 21.1868 12.9445 20.8092C13.3291 20.4316 13.5911 19.9505 13.6972 19.4267C13.8033 18.903 13.7488 18.3601 13.5407 17.8668C13.3325 17.3734 12.9801 16.9517 12.5278 16.655C12.0756 16.3584 11.5439 16.2 11 16.2ZM11 2.7C9.90598 2.7 8.85677 3.1267 8.08318 3.88622C7.3096 4.64574 6.875 5.67587 6.875 6.75V10.8H15.125V6.75C15.125 5.67587 14.6904 4.64574 13.9168 3.88622C13.1432 3.1267 12.094 2.7 11 2.7Z" fill="white"/></svg>`;
        }
      }
    }

    document.querySelectorAll('.bundle-slot').forEach(function(s) {
      s.classList.remove('active-slot-border');
    });
    var currentActiveSlot = document.getElementById('slot-' + activeStep);
    if (currentActiveSlot && completedCount < 4) {
      currentActiveSlot.classList.add('active-slot-border');
    }
  }

  function filterProducts(filterValue) {
    productCards.forEach(function(card) {
      if (filterValue === 'all' || card.dataset.category === filterValue) {
        card.style.display = 'flex';
      } else {
        card.style.display = 'none';
      }
    });
  }

  // --- Dawn-Native Integrated Refresh Function ---
  function refreshDawnCartDrawer() {
    if (window.Upcart && typeof window.Upcart.refreshPageCart === 'function') {
      window.Upcart.refreshPageCart();
    } else if (typeof window.upcartRefreshCart === 'function') {
      window.upcartRefreshCart();
    }

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents();
    }
  }

  tabButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      tabButtons.forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      filterProducts(btn.dataset.filter);
    });
  });

  quickAddTriggers.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.classList.contains('bundle-remove-mode')) {
        executeCardRemoval(this.dataset.id);
        return;
      }

      var card = this.closest('.bundle-product-card');
      var hasVariants = this.dataset.hasVariants === 'true';
      var totalOptionsCount = card.querySelectorAll('[data-option-index]').length;

      // Handle Color-Only Variants on Main Button Click
      if (hasVariants && totalOptionsCount === 1) {
        var selectedColor = card.querySelector('[data-option-index="option1"] .selected, .bundle-color-swatch-btn.selected');
        
        // If nothing is selected, fall back dynamically to first available
        if (!selectedColor) {
          selectedColor = card.querySelector('[data-option-index="option1"] .bundle-color-swatch-btn');
        }

        if (selectedColor) {
          var selectedColorVal = selectedColor.dataset.value;
          var variantsJsonEl = card.querySelector('[data-product-variants-json]');
          var variants = variantsJsonEl ? JSON.parse(variantsJsonEl.dataset.productVariantsJson) : [];
          
          var matchedVariant = variants.find(function(v) {
            return v.option1 === selectedColorVal || v.options.includes(selectedColorVal);
          });

          if (matchedVariant && matchedVariant.available) {
            var combinedTitle = btn.dataset.title + " - " + matchedVariant.title;
            var variantImage = matchedVariant.featured_image ? matchedVariant.featured_image.src : btn.dataset.image;
            btn.dataset.id = matchedVariant.id;
            executeCartAddition(matchedVariant.id, combinedTitle, variantImage, btn);
          }
        }
        return;
      }

      // Handle Standard Multi-option (Color + Size Drawers)
      if (hasVariants) {
        var drawer = card.querySelector('.bundle-variant-drawer');
        if (drawer) {
          var drawerHiddenBeforeClick = drawer.classList.contains('hidden');

          document.querySelectorAll('.bundle-variant-drawer').forEach(function(d) {
            if (d !== drawer) d.classList.add('hidden');
          });
          
          drawer.classList.toggle('hidden');

          // Alert validation logic if multi-option drawer was already open
          if (!drawerHiddenBeforeClick) {
            var sizeRow = card.querySelector('[data-option-index="option2"]');
            var selectedSize = sizeRow ? sizeRow.querySelector('.selected') : null;
            if (!selectedSize) {
              alert("Please select a size first!");
              return;
            }
          }

          // Automatically select the very first variant color option if nothing is chosen yet
          var colorRow = card.querySelector('[data-option-index="option1"]');
          if (colorRow && !colorRow.querySelector('.selected')) {
            var firstColorSwatch = colorRow.querySelector('.bundle-color-swatch-btn');
            if (firstColorSwatch) {
              firstColorSwatch.click();
            }
          }
        }
      } else {
        executeCartAddition(this.dataset.id, this.dataset.title, this.dataset.image, this);
      }
    });
  });

  document.querySelectorAll('.bundle-color-swatch-btn, .bundle-size-pill-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var container = this.closest('[data-option-index]');
      var card = this.closest('.bundle-product-card');
      if (!card) return; 
      
      var drawer = card.querySelector('.bundle-variant-drawer');
      var triggerBtn = card.querySelector('.quick-add-trigger');
      var mainCardImg = card.querySelector('.main-card-image');
      
      // Update the product card image dynamically if a color swatch is clicked
      if (this.classList.contains('bundle-color-swatch-btn') && this.dataset.variantImg) {
        mainCardImg.src = this.dataset.variantImg;
      }
      
      // Toggle selection styling in the active option row
      container.querySelectorAll('button').forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');

      var totalOptionsCount = card.querySelectorAll('[data-option-index]').length;

      // If product ONLY has color (1 total option group), return out early.
      if (totalOptionsCount === 1 && this.classList.contains('bundle-color-swatch-btn')) {
        return;
      }

      // 1. Gather all selected options across the entire card (swatches + drawer)
      var selectedOptions = {};
      card.querySelectorAll('[data-option-index]').forEach(function(row) {
        var selectedBtn = row.querySelector('.selected');
        if (selectedBtn) {
          selectedOptions[row.dataset.optionIndex] = selectedBtn.dataset.value;
        }
      });

      // 2. Safely parse JSON and identify total option categories
      var variantsJsonEl = card.querySelector('[data-product-variants-json]');
      var variants = variantsJsonEl ? JSON.parse(variantsJsonEl.dataset.productVariantsJson) : [];

      // 3. Resolve matched variant once all required options are selected
      if (Object.keys(selectedOptions).length === totalOptionsCount) {
        var matchedVariant = variants.find(function(v) {
          return Object.keys(selectedOptions).every(function(key) {
            return v[key] === selectedOptions[key];
          });
        });

        if (matchedVariant && matchedVariant.available) {
          var combinedTitle = triggerBtn.dataset.title + " - " + matchedVariant.title;
          var variantImage = matchedVariant.featured_image ? matchedVariant.featured_image.src : triggerBtn.dataset.image;

          triggerBtn.dataset.id = matchedVariant.id; 
          executeCartAddition(matchedVariant.id, combinedTitle, variantImage, triggerBtn);
          
          // Hide drawer and reset active option selections safely
          if (drawer) {
            drawer.classList.add('hidden');
          }
          card.querySelectorAll('button').forEach(function(b) { b.classList.remove('selected'); });
        }
      }
    });
  });

  function executeCartAddition(variantId, title, image, actionButton) {
    actionButton.disabled = true;
    actionButton.textContent = "Adding...";

    var completedCount = Object.values(state).filter(s => s !== null).length;
    var shouldShowDrawer = (completedCount >= 3); 

    if (!shouldShowDrawer) {
        window.suppressUpcart = true; 
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(res) { return res.json(); })
    .then(function(itemData) {
        syncExistingCart();
        actionButton.disabled = false;
        window.suppressUpcart = false; 
    })
    .catch(function(err) {
        console.error(err);
        actionButton.disabled = false;
        actionButton.textContent = "Add to Bundle";
        window.suppressUpcart = false;
    });
  }

  removeBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var targetVariantId = btn.dataset.variantId;
      if (targetVariantId) {
        executeCardRemoval(targetVariantId);
      }
    });
  });

  // Initial Sync on render
  syncExistingCart();

  // --- INTERCEPT DRAWER NETWORK ACTIVITY CHANGES ---
  var nativeFetch = window.fetch;
  window.fetch = function() {
    return nativeFetch.apply(this, arguments).then(function(response) {
      if (response && response.url && (
        response.url.includes('/cart/add') || 
        response.url.includes('/cart/change') || 
        response.url.includes('/cart/clear') || 
        response.url.includes('/cart/update')
      )) {
        setTimeout(function() {
          syncExistingCart();
        }, 350);
      }
      return response;
    });
  };

  // Checkout action binding safely moved inside DOMContentLoaded block
  var primaryCheckoutBtn = document.querySelector('.btn-primary-action');
  if (primaryCheckoutBtn) {
    primaryCheckoutBtn.addEventListener('click', function() {
      window.location.href = '/checkout';
    });
  }
});

// Disable Upcart popups/drawers during standard bundle page operations
window.addEventListener('aftersell-upcart:public-events:cart-loaded', function() {
    var isBundlePage = window.location.href.includes('limited-time-bundle') || 
                       window.location.href.includes('limited-time-bundle-2');

    if (isBundlePage) {
        console.log("Upcart drawer suppression active.");
        window.upcartOpenOnAddToCartOverride = false;
        
        if (window.Upcart && window.Upcart.observer) {
            window.Upcart.observer.disconnect();
        }
    }
});

// Bind close event to your close triggers
document.querySelectorAll('.close-color-drawer').forEach(function(closeBtn) {
  closeBtn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Find the closest product card and hide its drawer elements
    var card = this.closest('.bundle-product-card');
    if (card) {
      var sizeDrawer = card.querySelector('.bundle-variant-drawer');
      if (sizeDrawer) sizeDrawer.classList.add('hidden');
    }
  });
});